import { useEffect, useRef, useState } from "react";
import { Check, ChevronDown } from "lucide-react";

// قائمة منسدلة بثيم التطبيق (Neumorphism) بدل قائمة المتصفح الافتراضية.
export const NeuDropdown = ({ value, onChange, options, placeholder, icon: Icon,
                              testid = "neu-dropdown", className = "" }) => {
  const [open, setOpen] = useState(false);
  const box = useRef(null);
  const current = options.find((option) => option.value === (value ?? ""));

  useEffect(() => {
    const close = (event) => {
      if (box.current && !box.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  return (
    <div ref={box} className={`relative ${className}`} data-testid={testid}>
      <button
        type="button"
        data-testid={`${testid}-trigger`}
        onClick={() => setOpen((state) => !state)}
        className="flex h-12 w-full items-center gap-3 rounded-2xl border border-border/60 bg-background px-4 text-start shadow-neu-sm transition-shadow active:shadow-neu-in"
      >
        {Icon ? <Icon className="h-4 w-4 shrink-0 text-primary" /> : null}
        <span className="min-w-0 flex-1 truncate text-sm">
          {current?.label || placeholder}
        </span>
        <ChevronDown className={`h-4 w-4 shrink-0 text-muted-foreground transition-transform ${
          open ? "rotate-180" : ""}`} />
      </button>

      {open ? (
        <div data-testid={`${testid}-menu`}
             className="absolute inset-x-0 top-[calc(100%+0.5rem)] z-50 max-h-72 overflow-y-auto rounded-2xl bg-background p-2 shadow-neu">
          {options.map((option) => {
            const active = (value ?? "") === option.value;
            return (
              <button
                key={option.value || "__all"}
                type="button"
                data-testid={`${testid}-option-${option.value || "all"}`}
                onClick={() => {
                  onChange(option.value);
                  setOpen(false);
                }}
                className={`flex w-full items-center gap-2 rounded-xl px-3 py-2.5 text-start text-sm transition-colors ${
                  active
                    ? "bg-blue-500 font-bold text-white shadow-neu-in"
                    : "hover:bg-blue-500 hover:text-white focus:bg-blue-500 focus:text-white focus:outline-none"
                }`}
              >
                <Check className={`h-3.5 w-3.5 shrink-0 ${active ? "" : "opacity-0"}`} />
                <span className="min-w-0 flex-1 truncate">{option.label}</span>
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};
